import React from 'react';

const S = '#00F5A0';
const G = '#8892A4';

const ConfirmModal = ({
  open,
  title = 'Confirmer la suppression',
  message = 'Cette action est définitive et ne peut pas être annulée.',
  confirmLabel = 'Supprimer',
  cancelLabel = 'Annuler',
  danger = true,
  icon = null,
  onConfirm,
  onCancel,
}) => {
  if (!open) return null;

  return (
    <div
      style={{
        position: 'fixed', inset: 0,
        background: 'rgba(0,0,0,0.75)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        zIndex: 200, padding: 16,
      }}
      onClick={onCancel}
    >
      <div
        onClick={e => e.stopPropagation()}
        style={{
          background: 'rgba(10,22,40,0.98)',
          backdropFilter: 'blur(20px)',
          borderRadius: 16,
          width: '100%', maxWidth: 400,
          border: `1px solid ${danger ? 'rgba(239,68,68,0.25)' : 'rgba(255,255,255,0.08)'}`,
          padding: '28px 28px 24px',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: 14, marginBottom: 20 }}>
          <div style={{
            width: 40, height: 40, borderRadius: '50%', flexShrink: 0,
            background: danger ? 'rgba(239,68,68,0.12)' : 'rgba(0,245,160,0.1)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>
            {icon || (danger
              ? <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#f87171" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6"/><path d="M10 11v6M14 11v6"/><path d="M9 6V4h6v2"/></svg>
              : <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={S} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
            )}
          </div>
          <div>
            <h3 style={{ margin: '0 0 6px', fontSize: 17, fontWeight: 700, color: '#fff' }}>{title}</h3>
            <p style={{ margin: 0, fontSize: 14, color: G, lineHeight: 1.6 }}>{message}</p>
          </div>
        </div>

        <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
          <button
            onClick={onCancel}
            style={{
              background: 'rgba(255,255,255,0.06)', color: '#fff',
              border: '1px solid rgba(255,255,255,0.1)',
              borderRadius: 8, padding: '9px 18px',
              fontWeight: 600, fontSize: 14, cursor: 'pointer',
            }}
          >
            {cancelLabel}
          </button>
          <button
            onClick={onConfirm}
            style={{
              background: danger ? '#ef4444' : S,
              color: danger ? '#fff' : '#0A1628',
              border: 'none', borderRadius: 8, padding: '9px 18px',
              fontWeight: 700, fontSize: 14, cursor: 'pointer',
            }}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
